import Skeleton from "src/shared/components/layout/skeleton/Skeleton"

import "./DrawerSkeleton.css"

// Placeholder del detalle de habitación mientras se vuelve a consultar la habitación seleccionada
const DrawerSkeleton = () => (
    <div className="drawer-skeleton">
        <Skeleton.Item drawer className="drawer-skeleton__title" />
        <Skeleton.Item drawer className="drawer-skeleton__subtitle" />
        <Skeleton.Item drawer className="drawer-skeleton__card" />
        <Skeleton.Item drawer className="drawer-skeleton__tabs" />
        <Skeleton drawer elements={6} className="drawer-skeleton__list" />
        <Skeleton drawer elements={2} className="drawer-skeleton__buttons" />
    </div>
)

export default DrawerSkeleton
